/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Promos_Negative_StockInputs */



/**
* | output |
* | --- |
* | "More copies reported than your stock for: {names}. Saved anyway: check your inventory." |
*
* @param {Promos_Negative_StockInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_negative_stock = /** @type {((inputs: Promos_Negative_StockInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Negative_StockInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Plus d'exemplaires déclarés que votre stock pour : ${i?.names}. Enregistré quand même : vérifiez votre inventaire.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Más copias declaradas que su stock para: ${i?.names}. Guardado igualmente: revise su inventario.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mais cópias informadas que o seu estoque para: ${i?.names}. Salvo mesmo assim: confira seu inventário.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Più copie dichiarate del tuo stock per: ${i?.names}. Salvato comunque: controlla il tuo inventario.`)
	return /** @type {LocalizedString} */ (`More copies reported than your stock for: ${i?.names}. Saved anyway: check your inventory.`)
});